<template>
  <div class="home">
    <div class="container">
      <Header />
      <div class="row bg_ffffff">
        <div class="col-sm-12 padding_30 padding_top_0">
          <div class="col-sm-12 padding_0">
            <div
              class="
                col-sm-12
                padding_0 padding_top_15
                csfont_Signika_Lite
                color_6d6e71
                text-left
                font-size-16
              "
            >
              <form @submit.prevent="Submit">
                <div class="row px-3">
                  <!-- 1 row -->
                  <div
                    class="col-12 col-sm-12 p-0 px-3"
                    style="margin-top: 10px"
                  >
                    <h4 class="text-dark">Organisation</h4>
                    <span>{{ Organisation }}</span>
                  </div>
                  <!-- End row -->
                  <div class="col-12 col-sm-12">
                    <hr class="text-secondary" />
                    <h4 class="text-dark">Local Office</h4>
                  </div>
                  <!-- 1 row -->
                  <div class="col-12 col-sm-12 px-3">
                    <b>Address:</b>
                    {{ Local.Address }}
                  </div>
                  <!-- End row -->
                  <!-- 1 row -->
                  <div
                    class="col-12 col-sm-6 p-0 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Region : </b>
                    {{ Local.Province }}
                  </div>
                  <div
                    class="col-12 col-sm-6 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Province :</b>
                    {{ Local.City }}
                  </div>
                  <!-- End row -->
                  <!-- 1 row -->
                  <div
                    class="col-12 col-sm-6 p-0 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Direct Number :</b>
                    {{ Local.Tel }}
                  </div>
                  <div
                    class="col-12 col-sm-6 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Mobile Number (Optional) :</b>
                    {{ Local.Fax }}
                  </div>
                  <!-- End row -->
                  <!-- 1 row -->
                  <div
                    class="col-12 col-sm-6 p-0 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Email : </b>
                    {{ Email }}
                  </div>
                  <div
                    class="col-12 col-sm-6 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Website :</b>
                    {{ Website }}
                  </div>
                  <!-- End row -->
                  <div
                    class="col-12 col-sm-12"
                    :class="BangkokAddNone == true ? 'd-none' : ''"
                  >
                    <hr class="text-secondary" />
                    <h4 class="text-dark">Bangkok Office</h4>
                  </div>
                  <!-- 1 row -->
                  <div
                    class="col-12 col-sm-12 px-3"
                    :class="BangkokAddNone == true ? 'd-none' : ''"
                  >
                    <b>Address :</b>
                    {{ Bangkok.Address }}
                  </div>
                  <!-- End row -->
                  <!-- 1 row -->
                  <div
                    class="col-12 col-sm-6 p-0 my-2 px-3"
                    style="margin-top: 10px"
                    :class="BangkokAddNone == true ? 'd-none' : ''"
                  >
                    <b>Direct Number :</b>
                    {{ Bangkok.Tel }}
                  </div>
                  <div
                    class="col-12 col-sm-6 my-2 px-3"
                    style="margin-top: 10px"
                    :class="BangkokAddNone == true ? 'd-none' : ''"
                  >
                    <b>Mobile Number (Optional) :</b>
                    {{ Bangkok.Fax }}
                  </div>
                  <!-- End row -->
                  <div class="col-12 col-sm-12">
                    <hr class="text-secondary" />
                    <h4 class="text-dark">Authorised By</h4>
                  </div>
                  <!-- 1 row -->
                  <div class="col-12 col-sm-6 p-0 my-2 px-3">
                    <b>Name : </b>
                    {{ Represented.Name }}
                  </div>
                  <div class="col-12 col-sm-6 my-2 px-3">
                    <b>Title :</b>
                    {{ Represented.Title }}
                  </div>
                  <!-- End row -->
                  <!-- 1 row -->
                  <div
                    class="col-12 col-sm-6 p-0 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Direct Number :</b>
                    {{ Represented.Tel }}
                  </div>
                  <div
                    class="col-12 col-sm-6 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Mobile Number (Optional) :</b>
                    {{ Represented.Fax }}
                  </div>
                  <div
                    class="col-12 col-sm-6 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Email :</b>
                    {{ Represented.Email }}
                  </div>
                  <!-- End row -->
                  <div class="col-12 col-sm-12">
                    <hr class="text-secondary" />
                    <h4 class="text-dark">Contact Person</h4>
                  </div>
                  <!-- 1 row -->
                  <div class="col-12 col-sm-6 p-0 my-2 px-3">
                    <b>Name : </b>
                    {{ Alternate.Name }}
                  </div>
                  <div class="col-12 col-sm-6 my-2 px-3">
                    <b>Title :</b>
                    {{ Alternate.Title }}
                  </div>
                  <!-- End row -->
                  <!-- 1 row -->
                  <div
                    class="col-12 col-sm-6 p-0 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Direct Number :</b>
                    {{ Alternate.Tel }}
                  </div>
                  <div
                    class="col-12 col-sm-6 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Mobile Number (Optional) :</b>
                    {{ Alternate.Fax }}
                  </div>
                  <div
                    class="col-12 col-sm-6 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Email :</b>
                    {{ Alternate.Email }}
                  </div>
                  <!-- End row -->
                  <div class="col-12 col-sm-12">
                    <hr class="text-secondary" />
                  </div>
                  <!-- 1 row -->
                  <div
                    class="col-12 col-sm-12 p-0 my-2 px-3 pb-3"
                    style="margin-top: 10px"
                  >
                    <b>Description of Services (30 words) : </b> <br />
                    {{ DescriptionServices }}
                  </div>

                  <!-- End row -->
                  <!-- 1 row -->
                  <div
                    class="col-12 col-sm-12 p-0 my-2 px-3 pb-3"
                    style="margin-top: 10px"
                  >
                    <b>Experience in MICE Industry (50 words) : </b><br />
                    {{ ExperienceMICE }}
                  </div>

                  <!-- End row -->
                  <!-- 1 row -->
                  <div
                    class="col-12 col-sm-12 p-0 my-2 px-3 pb-3"
                    style="margin-top: 10px"
                  >
                    <b>Membership of Other Association(s) : </b><br />
                    <ol>
                      <li v-for="item in OAMembership" :key="item.name">
                        {{ item.name }}
                      </li>
                    </ol>
                  </div>
                  <!-- End row -->
                  <div class="col-12 col-sm-12">
                    <hr class="text-secondary" />
                  </div>
                  <!-- 1 row -->
                  <div class="col-12 col-sm-4 text-right">
                    <b class="text-dark">
                      <span class="text-danger">*</span> Documents:</b
                    >
                  </div>
                  <div class="col-12 col-sm-8">
                    <b>
                      <ol class="text-dark">
                        <li>
                          Letters of Recommendation from 2 TICA Members
                          <br />
                          <div class="filename">
                            <a :href="PreviewDocuments1" target="_blank">
                              - {{ Documents1 }} 
                              </a>
                          </div>
                          <div class="filename">
                            <a :href="PreviewDocuments5" target="_blank">
                              - {{ Documents5 }}
                            </a>
                          </div>
                        </li>
                        <li>
                          Copy of Business Registration
                          <br />
                          <div class="filename">
                            <a :href="PreviewDocuments2" target="_blank">
                              - {{ Documents2 }}
                            </a>
                          </div>
                        </li>
                        <li>
                          Copy of Business License(s)
                          <br />
                          <div class="filename">
                            <a :href="PreviewDocuments3" target="_blank">
                              - {{ Documents3 }}
                            </a>
                          </div>
                        </li>
                        <li>
                          Copy of Por Por .20
                          <br />
                          <div class="filename">
                            <a :href="PreviewDocuments4" target="_blank">
                              - {{ Documents4 }}
                            </a>
                          </div>
                        </li>
                      </ol>
                    </b>
                  </div>
                  <!-- End row -->
                  <div
                    class="col-12 col-sm-12"
                    :class="
                      MembershipCategory == '' || MembershipCategory == 'null'
                        ? 'd-none'
                        : ''
                    "
                  >
                    <hr class="text-secondary" />
                  </div>
                  <div
                    class="col-12 col-sm-12"
                    :class="
                      MembershipCategory == '' || MembershipCategory == 'null'
                        ? 'd-none'
                        : ''
                    "
                  >
                    <div class="row">
                      <!-- 1 row -->
                      <div class="col-12 col-sm-6 p-0 my-2 px-3">
                        <b>Membership Category: </b>
                        {{ MembershipCategory }}
                      </div>
                      <div class="col-12 col-sm-6 p-0 my-2 px-3">
                        <b>Subscription Rate THB: </b>
                        {{ SubscriptionRate }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 col-sm-12"
                    style="margin-top: 10px"
                    :class="
                      ForHotelOnly.NumberOfRooms == '' ||
                      ForHotelOnly.NumberOfRooms == '0' ||
                      ForHotelOnly.NumberOfRooms == 'null'
                        ? 'd-none'
                        : ''
                    "
                  >
                    <hr class="text-secondary" />
                    <h4 class="text-dark" style="margin-top: 20px">
                      For Hotel Only
                    </h4>
                  </div>
                  <div
                    class="col-12 col-sm-12"
                    :class="
                      ForHotelOnly.NumberOfRooms == '' ||
                      ForHotelOnly.NumberOfRooms == '0' ||
                      ForHotelOnly.NumberOfRooms == 'null'
                        ? 'd-none'
                        : ''
                    "
                  >
                    <div class="row">
                      <div class="col-12 col-sm-6 p-0 my-2 px-3">
                        <b>Number of Rooms : </b
                        >{{ ForHotelOnly.NumberOfRooms }}
                      </div>
                      <div
                        class="col-12 col-sm-12 p-0 my-2 px-3"
                        style="margin-top: 10px"
                      >
                        <span id="CategoryList">
                          (Please mark the check box below for your own
                          category)
                        </span>
                      </div>
                      <!-- category list A-->
                      <div
                        class="col-12 col-sm-12 my-2 text-left"
                        style="margin-top: 20px"
                      >
                        <div class="row">
                          <div class="col-12 col-sm-2 p-0 my-2 text-left">
                            <label for="CategoryA" class="pl-2">
                              {{ ForHotelOnly.CategoryName }}
                            </label>
                          </div>
                          <div class="col-12 col-sm-6 p-0 my-2">
                            <div class="pl-1">
                              {{ ForHotelOnly.Detail }}
                            </div>
                          </div>
                          <div class="col-4 col-sm-4 p-0 my-2">
                            <div class="pl-2">
                              <b class="pl-2">Total</b>:
                              {{ ForHotelOnly.TotalBaht }} THB
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--End category list A-->
                    </div>
                  </div>

                  <div class="col-12 col-sm-12">
                    <hr class="text-secondary" />
                    <div class="row tesxt-dark px-3">
                      <b class="col-6 col-sm-9 text-right">Joining Fee Rate</b>
                      <b class="col-6 col-sm-3 text-left">
                        <span class="px-2">THB {{ JoiningFeeRate }}</span>
                      </b>
                    </div>
                    <div class="row px-3">
                      <div class="col-6 col-sm-9 text-right">
                        <b>Grand Total </b>
                        <small>(excluding VAT 7%)</small>
                      </div>
                      <b class="col-6 col-sm-3 text-left">
                        <span class="px-2">THB {{ GrandTotal }}</span>
                      </b>
                    </div>
                    <br />
                  </div>
                  <div class="col-12 col-sm-12">
                    <hr class="text-secondary" />
                  </div>
                  <div
                    class="col-12 col-sm-6 p-0 my-2 px-3"
                    style="margin-top: 20px"
                  >
                    <b>Authorised Signature : </b>
                    <img :src="AuthorisedSignature" width="100%" />
                  </div>
                  <div
                    class="col-12 col-sm-6 p-0 my-2 px-3"
                    style="margin-top: 25px"
                  >
                    <b>Name in Capital Letters : </b><br />
                    {{ CapitalLetters.Name }}
                  </div>
                  <div
                    class="col-12 col-sm-6 p-0 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Title : </b>
                    {{ CapitalLetters.Title }}
                  </div>
                  <div
                    class="col-12 col-sm-6 p-0 my-2 px-3"
                    style="margin-top: 10px"
                  >
                    <b>Date : </b>
                    {{ CapitalLetters.Date }}
                  </div>
                  <div
                    class="col-12 col-sm-12 p-0 my-2 px-3"
                    style="margin-top: 5rem"
                  >
                    <b>
                      If you have any questions, please contact us at
                      <a href="mailto: info@tica.or.th">info@tica.or.th</a>,
                      <a href="mailto: office@tica.or.th">office@tica.or.th</a>,
                      or tel +662 938 6590-3.
                    </b>
                  </div>
                </div>
                <center>
                  <input
                    type="button"
                    class="btn btn-secondary mt-5 align-center pl-4 pr-4 goback"
                    value="Edit"
                    @click="$router.push(`/edit`)"
                  />
                  &emsp;
                  <input
                    type="submit"
                    class="btn btn-app mt-5 align-center"
                    value="Submit"
                  />
                </center>
                <br />
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
// CSS
import "@/assets/maincss/bootstrap.min.css";
import "@/assets/maincss/animate.css";
import "@/assets/maincss/fontface.css";
import "@/assets/css/font.css";
import "@/assets/maincss/custom.css";
import "@/assets/css/spacing.css";

// Component
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import { store } from "@/store";
import axios from "axios";
export default {
  name: "Home",
  store,
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      // Toggle btn
      disabledCatA: 0,
      disabledCatB: 0,
      disabledCatC: 0,
      disabledCatD: 0,
      disabledCatE: 0,
      disabledCheckbok: [0, 0, 0, 0, 0],
      disabledHotel: 0,
      disabledNotHotel: 0,
      // End toggle btn
      formID: null,
      Organisation: null,
      Local: {
        Address: null,
        Tel: null,
        Fax: null,
        Province: null,
        City: null,
      },
      Bangkok: {
        Address: null,
        Tel: null,
        Fax: null,
      },
      Email: null,
      Website: null,
      Represented: {
        Name: null,
        Title: null,
        Tel: null,
        Fax: null,
        Email: null,
      },
      Alternate: {
        Name: null,
        Title: null,
        Tel: null,
        Fax: null,
        Email: null,
      },
      DescriptionServices: null,
      ExperienceMICE: null,
      OAMembership: null,
      MembershipCategory: null,
      SubscriptionRate: null,
      ForHotelOnly: {
        NumberOfRooms: null,
        Category: [],
        CategoryName: null,
        Detail: null,
        TotalBaht: null,
      },
      AuthorisedSignature: null,
      AuthorisedSignatureURL: null,
      CapitalLetters: {
        Name: null,
        Title: null,
        Date: null,
      },
      Province: [
        {
          id: 1,
          value: "Central",
          city: [
            { value: "Kanchanaburi" },
            { value: "Nakhonpathom" },
            { value: "Nonthaburi" },
            { value: "Pathumthani" },
            { value: "Phetchaburi" },
            { value: "Prachuap Khiri Khan" },
            { value: "Samutprakarn" },
          ],
        },
        {
          id: 2,
          value: "East",
          city: [
            { value: "Chanthaburi" },
            { value: "Chonburi" },
            { value: "Trat" },
            { value: "Prachinburi" },
            { value: "Rayong" },
          ],
        },
        {
          id: 3,
          value: "North",
          city: [{ value: "Chiang-Mai" }, { value: "Chiang-Rai" }],
        },
        {
          id: 4,
          value: "North-East",
          city: [
            { value: "Khon-Kaen" },
            { value: "Nakhon-Ratchasima" },
            { value: "Ubon-Ratchathani" },
            { value: "Udon-Thani" },
          ],
        },
        {
          id: 5,
          value: "South",
          city: [
            { value: "Krabi" },
            { value: "Phang-Nga" },
            { value: "Phuket" },
            { value: "Samui" },
            { value: "Songkhla" },
            { value: "Suratthani" },
            { value: "Trang" },
          ],
        },
        {
          id: 6,
          value: "Bangkok",
          city: [{ value: "Bangkok" }],
        },
      ],
      status: null,
      GrandTotal: null,
      JoiningFeeRate: 1500,
      Documents1: null,
      Documents2: null,
      Documents3: null,
      Documents4: null,
      Documents5: null,
      PreviewDocuments1: null,
      PreviewDocuments2: null,
      PreviewDocuments3: null,
      PreviewDocuments4: null,
      PreviewDocuments5: null,
      BangkokAddNone: false,
      ipaddress: null,
      Alldata: null,
      AppID: null,
    };
  },
  async mounted() {
    fetch("https://api.ipify.org?format=json")
      .then((x) => x.json())
      .then(({ ip }) => {
        this.ipaddress = ip;
      });
    this.setData();
  },
  methods: {
    setData() {
      let data = JSON.parse(sessionStorage.getItem("membershipApplication"));
      this.Alldata = data;
      this.Organisation = data.Organisation;
      // local address
      this.Local.Address = data.LocalAddress;
      this.Local.Province = this.Province[data.LocalProvince - 1].value;
      this.Local.City = data.LocalCity;
      this.Local.Tel = data.LocalDirectNumber;
      this.Local.Fax = data.LocalMobile;
      this.Email = data.LocalEmail;
      this.Website = data.LocalWebsite;
      // Bangkok address
      this.BangkokAddNone = data.BangkokNone;
      this.Bangkok.Address = data.BangkokAddress;
      this.Bangkok.Tel = data.BangkokDirectNumber;
      this.Bangkok.Fax = data.BangkokMobile;
      //  Authorised by
      this.Represented.Name = data.AuthorisedName;
      this.Represented.Title = data.AuthorisedTitle;
      this.Represented.Tel = data.AuthorisedDirectNumber;
      this.Represented.Fax = data.AuthorisedMobile;
      this.Represented.Email = data.AuthorisedEmail;
      // Contact Person
      this.Alternate.Name = data.ContactPersonName;
      this.Alternate.Title = data.ContactPersonTitle;
      this.Alternate.Tel = data.ContactPersonDirectNumber;
      this.Alternate.Fax = data.ContactPersonMobile;
      this.Alternate.Email = data.ContactPersonEmail;
      //
      this.DescriptionServices = data.DescriptionOfServices;
      this.ExperienceMICE = data.ExperienceInMICEIndustry;
      this.OAMembership = data.MembershipOfOtherAssociation;
      // Category
      this.MembershipCategory = data.MembershipCategory.name.name;
      this.SubscriptionRate = data.SubscriptionRateTHB;
      this.ForHotelOnly.NumberOfRooms = data.ForHotelOnlyNumberOfRooms;
      this.ForHotelOnly.Category = data.ForHotelOnlyCategory;
      this.ForHotelOnly.TotalBaht = data.ForHotelOnlyTotalBaht;
      // Authorised Signature
      this.CapitalLetters.Name = data.CapitalLettersName;
      this.CapitalLetters.Title = data.CapitalLettersTitle;
      this.CapitalLetters.Date = data.CapitalLettersDate;
      // files
      this.AuthorisedSignature = "https://" + data.AuthorisedSignature.url;
      this.Documents1 =
        data.LORF2TMDocuments.Oldname + "." + data.LORF2TMDocuments.Type;
      this.Documents2 =
        data.COBRDocuments.Oldname + "." + data.COBRDocuments.Type;
      this.Documents3 =
        data.COBLDocuments.Oldname + "." + data.COBLDocuments.Type;
      this.Documents4 =
        data.COPPDocuments.Oldname + "." + data.COPPDocuments.Type;
      this.Documents5 =
        data.LORF2TM2Documents.Oldname + "." + data.LORF2TM2Documents.Type;
      this.PreviewDocuments1 =
        "https://tica.or.th/uploads/membership-application/save/assets/img/" +
        data.LORF2TMDocuments.Newname +
        "." +
        data.LORF2TMDocuments.Type;
      this.PreviewDocuments2 =
        "https://tica.or.th/uploads/membership-application/save/assets/img/" +
        data.COBRDocuments.Newname +
        "." +
        data.COBRDocuments.Type;
      this.PreviewDocuments3 =
        "https://tica.or.th/uploads/membership-application/save/assets/img/" +
        data.COBLDocuments.Newname +
        "." +
        data.COBLDocuments.Type;
      this.PreviewDocuments4 =
        "https://tica.or.th/uploads/membership-application/save/assets/img/" +
        data.COPPDocuments.Newname +
        "." +
        data.COPPDocuments.Type;
      this.PreviewDocuments5 =
        "https://tica.or.th/uploads/membership-application/save/assets/img/" +
        data.LORF2TM2Documents.Newname +
        "." +
        data.LORF2TM2Documents.Type;
      if (
        data.COBLDocuments.Oldname == "null" ||
        data.COBLDocuments.Oldname == ""
      ) {
        this.PreviewDocuments3 = "";
        this.Documents3 = "";
      }

      if (this.ForHotelOnly.Category == "0") {
        this.ForHotelOnly.CategoryName = "Category A:";
        this.ForHotelOnly.Detail =
          "Hotel with meeting facilities of over 600 capacities (theatre style) THB 60 per 1 guest room";
      } else if (this.ForHotelOnly.Category == "1") {
        this.ForHotelOnly.CategoryName = "Category B:";
        this.ForHotelOnly.Detail =
          "Hotel with meeting facilities of less than 600 capacities (theatre style) THB 36 per 1 guest room";
      } else if (this.ForHotelOnly.Category == "2") {
        this.ForHotelOnly.CategoryName = "Category C:";
        this.ForHotelOnly.Detail =
          "Hotel without meeting facilities THB 12 per 1 guest room";
      } else if (this.ForHotelOnly.Category == "3") {
        this.ForHotelOnly.CategoryName = "Category D:";
        this.ForHotelOnly.Detail =
          "Up-Country Hotels with meeting facilities of over 600 capacities (Theatre style) THB 30 per 1 guest room";
      } else if (this.ForHotelOnly.Category == "4") {
        this.ForHotelOnly.CategoryName = "Category E:";
        this.ForHotelOnly.Detail =
          "Up-Country Hotels with meeting facilities of less than 600 Capacity (Theatre style) THB 18 per 1 guest room";
      } else {
        this.ForHotelOnly.CategoryName = null;
        this.ForHotelOnly.Detail = null;
      }
      this.GrandTotal =
        parseInt(this.SubscriptionRate) +
        parseInt(this.ForHotelOnly.TotalBaht) +
        this.JoiningFeeRate;
    },
    async getFormID() {},
    async Submit() {
      await axios
        .get(
          "https://www.tica.or.th/uploads/membership-application/save/getDataID.php"
        )
        .then((response) => {
          if (
            response.data == null ||
            response.data == "null" ||
            response.data == ""
          ) {
            this.AppID = 1;
          } else {
            this.AppID = parseInt(response.data) + 1;
          }
        });
      if (window.confirm("Are you sure?")) {
        // Post Data to php
        const data = new FormData();
        data.append("Appid", this.AppID);
        data.append("Data", JSON.stringify(this.Alldata));
        data.append("date", this.CapitalLetters.data);
        data.append("ipaddress", this.ipaddress);
        var url =
          "https://www.tica.or.th/uploads/membership-application/save/insertData.php";

        var header = { headers: { "Content-Type": "application/json" } };
        await axios.post(url, data, header).then((response) => {
          sessionStorage.setItem("Appid", response.data.id);
          console.log(response.data);
        });
        window.location.href = "./pdfmaf";
      } else {
        console.log("cancel");
      }
    },
  },
};
</script>

<style scoped>
.w-100 {
  width: 100%;
}
.bg_dark_blue {
  background-color: #102f50;
}
.text-secondary {
  border-top: 1px solid #bfc6cc !important;
}
.catgory-input {
  position: absolute !important;
  right: 0 !important;
  padding-right: 5% !important;
}
.pt-3 {
  padding-top: 1.5rem !important;
}
.pb-3 {
  padding-bottom: 1.5rem !important;
}
.d-none {
  display: none !important;
}

.pl-2 {
  padding-left: 1rem !important;
}
.pr-2 {
  padding-right: 1rem !important;
}
.pl-3 {
  padding-left: 1.5rem !important;
}
.pr-3 {
  padding-right: 1.5rem !important;
}
.pl-4 {
  padding-left: 2rem !important;
}
.pr-4 {
  padding-right: 2rem !important;
}
.goback {
  border: 1px solid black;
  color: black;
}
.home {
  background-color: #3c3c3b;
  font-family: Georgia, Times, serif;
}
.btn-app {
  color: #fff !important;
  background-color: #102f51 !important;
}
.btn-app:hover {
  color: #fff !important;
  background-color: #235a99 !important;
}

.filename {
  color: #337ab7;
  text-decoration: none;
  white-space: nowrap;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>